import React, { useContext } from 'react';
import { JobSearchContext } from '../../context';

const DidYouMean = () => {
  const { setKeyword, setKeywordUserInput, suggestions, } = useContext(JobSearchContext);

  if (!suggestions.length) return null;

  // Given a suggestion, sets that value in the context state to trigger a search
  // and reflect that value in the URL and the "Keywords" input field as well.
  const triggerKeywordSearch = (suggestion: string) => {
    setKeyword(suggestion);
    setKeywordUserInput(suggestion);
  };

  return (
    <div className='did-you-mean'>
      <span className='fal icon-question-circle me-1' />
      <span className='text'>Did you mean: </span>
      {suggestions.map((suggestion, index) => (
        <span key={suggestion.text}>
          <span
            dangerouslySetInnerHTML={{ __html: suggestion.highlighted }}
            className='cursor-pointer cta-link'
            onClick={() => triggerKeywordSearch(suggestion.text)}
          />
          {index + 1 !== suggestions.length && <span className='separator-line'>·</span>}
        </span>
      ))}
    </div>
  );
};

export default DidYouMean;
